<template>
  <div class="g-categories-side-menu scroll-y" ref="categoriesSideBar">
    <button @click="openCategories" class="show-categories-btn" :ripple="false">
      <img src="../../assets/images/controls.svg" alt=""/>
    </button>
    <div>
      <h2>{{ $t('categories.categories') }}</h2>
      <v-expansion-panel
        v-model="panel"
        focusable
        class="nav-categories"
      >
        <v-expansion-panel-content
          v-for="(category, i) in categories"
          :key="i"
          class="nav-category-content"
        >
          <v-icon slot="actions" color="primary">$vuetify.icons.expand</v-icon>
          <div slot="header" class="nav-category-title">{{ category.displayInfo.name }}</div>
          <v-card>
            <v-list subheader>
              <v-list-tile
                v-for="subCheckbox in category.subcategories"
                :key="subCheckbox.id"
              >
                <label class="g-checkbox">
                  <input type="checkbox" v-model="productsFilter.buttonGroup" @change="changeCheckbox()" :value="subCheckbox.id">
                  <span class="g-label">{{subCheckbox.displayInfo.name}}</span>
                  <span class="checkmark"/>
                </label>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '../../event-bus'

export default {
  name: 'NeedCategories',
  data: () => ({
    categoryIdActive: null,
    productListCategories: [],
    checkboxCategory: null,
    panel: null,
    isLogged: false,
    fromMainSearch: false,
    firstTimeReload: true,
    productsFilter: {
      buttonGroup: []
    }
    // categories: []
  }),
  computed: {
    ...mapState({
      categories: state => state.categoriesNeeds.needs,
      mainSearchNeeds: state => state.categoriesNeeds.mainSearchNeeds,
      languages: state => state.common.languages
    })
  },
  created () {
    // this.categoryList()
    EventBus.$off('language-changed')
    EventBus.$off('delete-checkbox')
    EventBus.$off('select-category')
    EventBus.$off('set-default-params')
    EventBus.$on('language-changed', this.languageChanged())
    EventBus.$on('delete-checkbox', this.deleteCheckbox)
    EventBus.$on('select-category', this.selectCategory)
    EventBus.$on('set-default-params', this.setDefaultParams)
  },
  beforeMount () {
  },
  mounted () {
    this.productsFilter.buttonGroup = this.mainSearchNeeds.filter || []

    if (Object.keys(this.$route.params).length === 0) {
      if (this.panel === null && this.mainSearchNeeds.cat === null) {
        this.getProductsFilterProductsWhereIn()
      }
    }
  },
  methods: {
    changeCheckbox () {
      this.getProductsFilterProductsWhereIn()
    },
    languageChanged (lang) {
      if (['Needs', 'need'].includes(this.$route.name)) {
        this.categoryList()
      }
    },
    categoryList () {
      this.$store.dispatch('categoriesNeeds/needsCat', {changeListState: true}).then(res => {
        if (this.panel !== null) {
          this.checkboxCategory = this.categories[this.panel]
          EventBus.$emit('select-deselect-category', {checkboxCategory: this.checkboxCategory})
        }
      })
    },
    selectDeselectCategory (category) {
      if (this.$route.name !== 'Needs') {
        this.$router.push('/needs')
      }
      if (category.id !== this.categoryIdActive) {
        this.categoryIdActive = category.id
        this.checkboxCategory = category
      } else if (category.id === this.categoryIdActive) {
        this.categoryIdActive = null
        this.checkboxCategory = null
      }
      this.getProductsFilterProductsWhereIn()
    },
    getProductsFilterProductsWhereIn () {
      let productsWhereIn = []
      if (this.checkboxCategory) {
        if (this.productsFilter.buttonGroup.length > 0) {
          productsWhereIn = this.productsFilter.buttonGroup
        } else {
          productsWhereIn.push(this.categoryIdActive)
          if (this.checkboxCategory.subcategories) {
            this.checkboxCategory.subcategories.forEach((subcategory) => {
              productsWhereIn.push(subcategory.id)
            })
          }
        }
      }
      this.setMainSearchData()
      EventBus.$emit('select-deselect-category', {productsWhereIn, checkboxCategory: this.checkboxCategory})
    },
    deleteCheckbox (productsWhereIn) {
      this.productsFilter.buttonGroup = productsWhereIn.productsWhereIn
      this.getProductsFilterProductsWhereIn()
    },
    selectCategory (cat) {
      const {category, filter} = cat
      this.categories.forEach((item, i) => {
        if (category.id === item.id) {
          if (filter) {
            this.productsFilter.buttonGroup = filter
          }
          if (this.panel === i) {
            this.checkboxCategory = category
            this.getProductsFilterProductsWhereIn()
          } else {
            this.fromMainSearch = true
            this.panel = i // Here works watch panel
          }
        }
      })
    },
    setMainSearchData () {
      let data = {
        cat: this.categoryIdActive,
        filter: Object.assign([], this.productsFilter.buttonGroup)
      }
      this.$store.dispatch('categoriesNeeds/setMainSearchData', data)
    },
    setDefaultParams () {
      let data = {
        cat: null,
        filter: []
      }
      this.$store.dispatch('categoriesNeeds/setMainSearchData', data)
      if (this.panel !== null) {
        this.panel = null
      } else {
        this.getProductsFilterProductsWhereIn()
      }
    },
    openCategories () {
      this.$refs.categoriesSideBar.classList.toggle('open')
    }
  },
  watch: {
    panel: function (newVal, oldVal) {
      if (oldVal !== null && newVal !== null && this.categories[newVal]) {
        if (!this.fromMainSearch) {
          this.productsFilter.buttonGroup = []
        }
        this.selectDeselectCategory(this.categories[newVal])
      } else if (oldVal === null && newVal !== null && this.categories[newVal]) {
        this.selectDeselectCategory(this.categories[newVal])
        EventBus.$emit('delete-search-autocomplete')
      } else {
        this.productsFilter.buttonGroup = []
        this.selectDeselectCategory(this.checkboxCategory)
      }
      this.fromMainSearch = false
    }
  },
  beforeUpdate () {
    if (this.firstTimeReload) {
      if (Object.keys(this.$route.params).length === 0 && this.mainSearchNeeds.cat !== null) {
        this.categories.forEach((item, i) => {
          if (this.mainSearchNeeds && this.mainSearchNeeds.cat === item.id) {
            this.panel = i
            this.firstTimeReload = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/desktop/categories.scss";
</style>



// WEBPACK FOOTER //
// src/components/categories/needCategories.vue